<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0" align="center" justify="center">
      <v-col cols="12" class="pa-0 ma-0">
        <v-card
          class="d-flex flex-column pa-0"
          flat
          :style="`background-color: ${settings.background_color}`"
        >
          <!-- Header Component -->
          <HeaderComponent
            class="px-5"
            :timeZone="timeZone"
            :stop_name="stop_name"
            :name="settings.name"
            :header_background_color="settings.header_background_color"
            :header_font_color="settings.header_font_color"
          />
          <!-- Service Component for each service -->
          <ServiceComponent
            class="pr-3 pl-3"
            :background_color="settings.background_color"
            :font_color="settings.font_color"
            :timeZone="timeZone"
            v-for="(service, index) in data"
            :key="index"
            :index="index"
            :service="service"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderComponent from "./HeaderComponent.vue";
import ServiceComponent from "./ServiceComponent.vue";

export default {
  components: {
    HeaderComponent,
    ServiceComponent,
  },
  props: {
    settings: Object,
    timeZone: String,
    stop_name: String,
    data: Array,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped>
html,
body,
.v-application {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}

.v-card {
  width: 100%;
  height: 100%;
}
</style>
